import PropTypes from 'prop-types';
import { AutoComplete } from 'antd';
import { HELPER_TEXT_TYPES } from '@icp/form-renderer-core';
import { useMemo } from 'react';
import { get } from 'lodash-es';
import { Loading } from '@icp/components';
import FieldTitle from '../../FieldTitle';
import FormHelperText from '../../FormHelperText';
import ItemField from '../SelectElement/ItemField';
import { filterOption } from '../SelectElement/utils';

function AutoCompleteAnt(props) {
  const {
    keyPath,
    id,
    title,
    value,
    componentProps,
    fieldTitleProps,
    validation,
    disabled,
    readonly,
    status,
    helpers,
    onChange,
    onTouchChanged,

    readonlyText,
    searchTextColIds,
    loading,
    options,
    mapping,
    itemField,
    onSearch,
  } = props;

  const antOptions = useMemo(() => {
    if (!options || !options.length) return [];
    return options.map((op) => ({
      value: String(op[mapping.value] ?? ''),
      label: get(op, mapping.label) ?? '',
      rawData: op,
    }));
  }, [options, mapping]);

  const handleFilterOption = (inputValue, option) => {
    return filterOption(inputValue, option.rawData, searchTextColIds);
  };

  const handleSelect = (val) => {
    onChange(val);
  };

  const handleChange = (val) => {
    onChange(val);
  };

  return (
    <>
      <FieldTitle required={validation?.required} {...fieldTitleProps}>
        {title}
      </FieldTitle>
      <div>
        {readonly ? (
          <span className="readonly-text">{readonlyText}</span>
        ) : (
          <AutoComplete
            {...componentProps}
            id={id}
            value={value ?? ''}
            disabled={disabled}
            status={status}
            options={loading ? [] : antOptions}
            filterOption={handleFilterOption}
            onSelect={handleSelect}
            onChange={handleChange}
            onSearch={onSearch}
            onBlur={onTouchChanged}
            notFoundContent={
              loading ? <Loading size={16} delayed={false} style={{ height: 56 }} /> : null
            }
            optionRender={(option) => {
              if (itemField) {
                return (
                  <ItemField keyPath={keyPath} itemField={itemField} option={option.data.rawData} />
                );
              }
              return option.data.label;
            }}
          />
        )}
        <FormHelperText helpers={helpers} />
      </div>
    </>
  );
}

AutoCompleteAnt.propTypes = {
  keyPath: PropTypes.string,
  id: PropTypes.string,
  title: PropTypes.string,
  value: PropTypes.string,
  componentProps: PropTypes.shape({}),
  mapping: PropTypes.shape({
    value: PropTypes.string,
    label: PropTypes.string,
  }),
  options: PropTypes.arrayOf(PropTypes.shape({})),
  searchTextColIds: PropTypes.arrayOf(PropTypes.string),
  itemField: PropTypes.shape({}),
  fieldTitleProps: PropTypes.shape({}),
  validation: PropTypes.shape({
    required: PropTypes.bool,
  }),
  disabled: PropTypes.bool,
  readonly: PropTypes.bool,
  status: PropTypes.oneOf(HELPER_TEXT_TYPES),
  helpers: PropTypes.arrayOf(
    PropTypes.shape({
      status: PropTypes.oneOf(HELPER_TEXT_TYPES),
      text: PropTypes.string,
    }),
  ),
  onChange: PropTypes.func,
  onTouchChanged: PropTypes.func,
  readonlyText: PropTypes.string,
  loading: PropTypes.bool,
  onSearch: PropTypes.func,
};

export default AutoCompleteAnt;
